import React from 'react';
import PropTypes from 'prop-types';
import { useFormikContext } from 'formik';
import { Flex, Text, Box } from 'rebass/styled-components';
import { FormInput, FormTextarea } from '@getro/rombo';

export const HeaderSection = ({ title, description, onUpdate }) => {
  const { errors, touched, setFieldTouched } = useFormikContext();

  return (
    <Flex sx={{ flexDirection: 'column', gap: '8px', width: '100%' }}>
      <Text
        sx={{
          fontSize: '12px',
          fontWeight: '500',
          color: 'text.subtle',
          textTransform: 'uppercase',
          letterSpacing: '1px',
        }}
      >
        Header
      </Text>
      <Box>
        <FormInput
          label="Title"
          labelExtra="Required"
          placeholder="Enter form title"
          field={{
            name: 'title',
            value: title,
            onChange: (e) => onUpdate('title', e.target.value),
            onBlur: () => setFieldTouched('title', true),
          }}
          form={{
            errors: { title: errors.title },
            touched: { title: touched.title },
          }}
        />
      </Box>
      <Box>
        <Text
          sx={{
            fontSize: '14px',
            fontWeight: '500',
            color: 'text.dark',
            mb: '4px',
          }}
        >
          Description
        </Text>
        <FormTextarea
          value={description}
          onChange={(e) => onUpdate('description', e.target.value)}
          placeholder="Enter form description"
          rows={4}
        />
      </Box>
    </Flex>
  );
};

HeaderSection.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  onUpdate: PropTypes.func.isRequired,
};
